import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import ReactQuill from "react-quill";
import api from "../../api";
import Logo from "../../images/logo-2.png";
import "react-quill/dist/quill.snow.css";

function CustomPushNotification({}) {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [loader, setLoader] = useState(false);

  const handleSubmit = async (category) => {
    try {
      let checkValidate = validate();
      if (checkValidate) {
        return checkValidate;
      }
      setLoader(true);
      let payload = {
        title,
        message,
        category,
      };
      // console.log(payload);
      const userData = await api.sendCustomPushNotif(payload);
      // console.log(userData);
      if (userData.success) {
        alert(userData.message);
        setLoader(false);
        setTitle("");
        setMessage("");
      } else {
        alert(userData.message || "Something went wrong, email not sent ");
        setLoader(false);
      }
      // console.log(value);
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert("Something went wrong, email not sent ");
    }
  };

  const validate = () => {
    if (!title) {
      return "Title is required.";
    }
    if (title.length > 50) {
      return "Title can be greater than 50 character.";
    }
    if (!message) {
      return "message is required.";
    }
    if (message.length > 100) {
      return "Message can be greater than 50 character.";
    }
    return false;
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid">
        {/* Content Row */}
        <div className="row">
          {/* Area Chart */}
          <div className="col">
            <div className="row mx-0 drivers-row">
              <div className="col-xl-6 col-md-7 d-flex justify-content-between pr-0">
                <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                  Send Custom Push Notification To App
                </h4>
              </div>
            </div>
            <div className="card sortby-box br-10 border-transparent mt-3">
              <div className="card-header br-10  bg-white border-transparent py-3 ">
                <div className="form-group mb-3">
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="Title..."
                    value={title}
                  />
                </div>
                <div className="form-group mb-3">
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Message..."
                    value={message}
                  />
                </div>
                <div className="sendMailBtn mt-3">
                  <button
                    onClick={() => handleSubmit("paid")}
                    className="btn-dark"
                  >
                    Send to Paid Users
                  </button>
                </div>
                <div className="sendMailBtn mt-3">
                  <button
                    onClick={() => handleSubmit("unpaid")}
                    className="btn-dark"
                  >
                    Send to Non-Paid Users
                  </button>
                </div>
              </div>
            </div>
            {/* table */}
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && (
        <div className="seekoLoader">
          <div className="loader">
            <img src={Logo} alt="loader" />
          </div>
        </div>
      )}
    </>
  );
}

export default CustomPushNotification;
